import React, { Component } from "react"
import { connect } from "react-redux"
import Dialog from "react-toolbox/lib/dialog"
import Input from "react-toolbox/lib/input"
import Dropdown from "react-toolbox/lib/dropdown"
import Division from "../../components/Division"
import Spacer from "../../components/Spacer"
import Checkbox from "react-toolbox/lib/checkbox/Checkbox"
import Autocomplete from "react-toolbox/lib/autocomplete/Autocomplete"
import * as strings from "../../strings"
import _ from "lodash"

class ExpenseTypeDialog extends Component {
  props: {
    onSubmit: ( mixed ) => any,
    onCancel: ( mixed ) => any,
    visible: boolean,
    defaultValues: any,
    BillingPhaseEnum: mixed,
    DebtPhaseEnum: mixed,
  }

  state = {
    name: "",
    billingPhase: undefined,
    debtPhase: [],
    automaticExpensesEnabled: false,
  }

  componentDidUpdate ( prevProps ) {
    if ( !_.isEqual( prevProps.defaultValues, this.props.defaultValues ) ) {
      if ( this.props.defaultValues ) {
        this.setState( this.props.defaultValues )
      } else {
        this.resetForm()
      }
    }
  }

  resetForm = () => this.setState( {
    name: "",
    billingPhase: undefined,
    debtPhase: [],
    automaticExpensesEnabled: false,
  } )

  onFormChange = field => newValue => this.setState( {
    [ field ]: newValue,
  } )

  submitExpenseType = () => {
    this.props.onSubmit( this.state )
    this.resetForm()
  }

  render () {
    return (
      <Dialog
        actions={[
          { label: strings.generalStrings.cancel, onClick: this.props.onCancel },
          { label: strings.generalStrings.keep, onClick: this.submitExpenseType },
        ]}
        active={this.props.visible}
        onEscKeyDown={this.props.onCancel}
        onOverlayClick={this.props.onCancel}
        type="small"
      >
        <Division title={strings.management.addExpenseType} />
        <Input
          type="text"
          label={strings.generalStrings.name}
          value={this.state.name}
          onChange={this.onFormChange( "name" )}
        />
        <Dropdown
          label={strings.generalStrings.billingPhase}
          source={_.map( this.props.BillingPhaseEnum, val => ( {
            label: strings.BillingPhaseTranslation[ val.name ],
            value: val.name,
          } ) ) }
          value={this.state.billingPhase}
          onChange={this.onFormChange( "billingPhase" )}
        />
        <Autocomplete
          direction="down"
          selectedPosition="above"
          label={strings.processes.phase}
          onChange={this.onFormChange( "debtPhase" )}
          source={_.chain( this.props.DebtPhaseEnum )
            .map( dp => dp.name )
            .reduce( ( acc, name ) => ( {
              ...acc,
              [ name ]: name,
            } ), {} )
            .mapValues( name => strings.DebtPhaseTranslation[ name ] )
            .value()
          }
          value={this.state.debtPhase}
        />
        <Spacer size={2} />
        <Checkbox
          label={strings.expenses.automaticExpenseRule}
          checked={this.state.automaticExpensesEnabled}
          onChange={this.onFormChange( "automaticExpensesEnabled" )}
        />
      </Dialog>
    )
  }
}

export default connect( state => ( {
  BillingPhaseEnum: state.suggestions.BillingPhaseEnum,
  DebtPhaseEnum: state.suggestions.DebtPhaseEnum,
} ) )( ExpenseTypeDialog )



// WEBPACK FOOTER //
// ./src/views/ManageExpenseTypes/ExpenseTypeDialog.jsx